module.exports = __webpack_public_path__ + "static/media/SDTM11-256.3001f22a.jpg";